import { useUTM } from '@repo/platform';
import { useRouter } from 'next/router';
import { useLazyLoadQuery } from 'react-relay';

import { benefitLandingModalQuery } from '@/__generated__/benefitLandingModalQuery.graphql';
import { landingModalQuery } from '@/graphql/query/partner/benefit';
import { INVITE_EVENT_SESSION_STORAGE_KEY } from '@/lib/constants/event';

export const useProceedingEvent = () => {
  const { utmData } = useUTM();
  const data = useLazyLoadQuery<benefitLandingModalQuery>(landingModalQuery, {
    utmSource: utmData?.utmSource || '',
    utmCampaign: utmData?.utmCampaign || ''
  });

  return data.landingModal;
};

export const useInviteEventSessionData = () => {
  const router = useRouter();

  const get = () => {
    const savedData = sessionStorage.getItem(INVITE_EVENT_SESSION_STORAGE_KEY);
    if (savedData) {
      return JSON.parse(savedData);
    } else if (router.query.invite_code && router.query.promotion_code) {
      return {
        inviteCode: router.query.invite_code,
        promotionCode: router.query.promotion_code
      };
    }

    return null;
  };

  const set = () => {
    if (router.query.invite_code && router.query.promotion_code) {
      sessionStorage.setItem(
        INVITE_EVENT_SESSION_STORAGE_KEY,
        JSON.stringify({
          inviteCode: router.query.invite_code,
          promotionCode: router.query.promotion_code
        })
      );
    }
  };

  return { get, set };
};
